/**
 * Store: Market switcher
 * -----------------------------------------------------------------------------
 *
 */
export default {
  namespaced: true,

  state: () => ({
    geolocation: {
      code: '',
      name: '',
    },
    localization: {
      countries: [],
    },
    country: {
      name: '',
      code: '',
      currency: {
        code: '',
        symbol: '',
      },
    },
  }),

  mutations: {

    /**
     * Set geolocation.
     * @param {Object} geolocation - Formatted geolocation.
     * @param {String} geolocation.countryCode - Country ISO code.
     * @param {String} geolocation.name - Country name.
     */
    SET_GEOLOCATION(state, geolocation) {
      state.geolocation = geolocation
    },

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    SET_LOCALIZATION(state, localization) {
      state.localization = localization
    },

    /**
     * Set country.
     * @param {Object} country - Shopify localization.country.
     */
    SET_COUNTRY(state, country) {
      state.country = country
    },
  },

  actions: {

    /**
     * Set geolocation.
     * @param {Object} response - Response from Shopify geolocation app.
     */
    setGeolocation({ commit }, response) {
      const { name, handle: code } = response.detected_values.country
      commit('SET_GEOLOCATION', { code, name })
    },

    /**
     * Set localization.
     * @param {Object} localization - Shopify localization.
     */
    setLocalization({ commit }, localization) {
      commit('SET_LOCALIZATION', localization)
    },

    /**
     * Set country.
     * @param {String} country - Shopify localization.country.
     */
    setCountry({ commit }, country) {
      commit('SET_COUNTRY', country)
    },
  },
}
